export default __webpack_public_path__ + "Mask-group-18.62e468.svg";